import React, { useMemo } from 'react';
import { modeKeys } from './config';
import BaseField from './components/BaseField';
import EditableContent from './components/EditableContent';
import Result from './components/Result';

const getComponent = (mode) => {
  switch (mode) {
    case modeKeys.setable:
      return BaseField;

    case modeKeys.editable:
      return EditableContent;

    case modeKeys.readable:
      return Result;

    default:
      return null;
  }
};

const emptyObj = {};

// props = { mode, value, onChange, fieldProps = emptyObj }
const EditableField = (props) => {
  const { mode, value, fieldProps = emptyObj, ...rest } = props;

  const Component = useMemo(() => getComponent(mode), [mode]);

  const restProps = mode === modeKeys.readable ? {} : { ...rest, fieldProps };

  return <Component value={value} {...restProps} />;
};

EditableField.modes = modeKeys;

export default EditableField;
